export default {

  initialize: (DSN, raven) => {
    if (DSN && raven) {
      raven.config(DSN).install();
    }
  }

};
